export default "__VITE_ASSET__C4nlNO5___"